import Vue from 'vue'
import VueRouter from 'vue-router'
import App from '../App'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: App,
    redirect: 'login',
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Login/index.vue')
      },
      {
        path: '/todo',
        name: 'todo',
        component: () => import('@/views/Todo/index.vue')
      },
      {
        path: '/bargainApproval',
        name: 'bargainApproval',
        component: () => import('@/views/BargainApproval/index.vue')
      },
      {
        path: '/accountOrderApproval',
        name: 'accountOrderApproval',
        component: () => import('@/views/AccountOrderApproval/index')
      },
      {
        path: '/payApproval',
        name: 'payApproval',
        component: () => import('@/views/PayApproval/index')
      },
      {
        path: '/poApproval',
        name: 'poApproval',
        component: () => import('@/views/PoApproval/index')
      },
      {
        path: '/pomApproval',
        name: 'pomApproval',
        component: () => import('@/views/PomApproval/index')
      },
      {
        path: '/prApproval',
        name: 'prApproval',
        component: () => import('@/views/PrApproval/index')
      },
      {
        path: '/cotApproval',
        name: 'cotApproval',
        component: () => import('@/views/CotApproval/index')
      },
      {
        path: '/supplierApplyApproval',
        name: 'supplierApplyApproval',
        component: () => import('@/views/SupplierApplyApproval/index')
      },
      {
        path: '/supplierResultApproval',
        name: 'supplierResultApproval',
        component: () => import('@/views/SupplierResultApproval/index')
      },
      {
        path: '/receiptStateChangeApproval',
        name: 'receiptStateChangeApproval',
        component: () => import('@/views/ReceiptStateChangeApproval/index')
      },
      {
        path: '/qualifyApplyApproval',
        name: 'qualifyApplyApproval',
        component: () => import('@/views/QualifyApproval/index')
      },
      {
        path: '/generalApplyApproval',
        name: 'generalApplyApproval',
        component: () => import('@/views/GeneralApproval/index')
      },
      // 合同付款任务审批
      {
        path: '/contractPaymentTaskApproval',
        name: 'contractPaymentTaskApproval',
        component: () => import('@/views/ContractPaymentTaskApproval/index')
      },
      // 定价方式审批
      {
        path: '/pmPriceModeApproval',
        name: 'pmPriceModeApproval',
        component: () => import('@/views/PmPriceModeApproval/index')
      },
      // 变更定价方式审批
      {
        path: '/changePriceModeApproval',
        name: 'changePriceModeApproval',
        component: () => import('@/views/ChangePriceModeApproval/index')
      },
      // 新品定价审批
      {
        path: '/newProductPricingApproval',
        name: 'newProductPricingApproval',
        component: () => import('@/views/NewProductPricingApproval/index')
      },
      // 联动调价审批
      {
        path: '/linkagePriceAdjustApproval',
        name: 'linkagePriceAdjustApproval',
        component: () => import('@/views/LinkagePriceAdjustApproval/index')
      },
      // 物料成本调整审批
      {
        path: '/matCostAdjustApproval',
        name: 'matCostAdjustApproval',
        component: () => import('@/views/MatCostAdjustApproval/index')
      },
      // 老品新供方定价审批
      {
        path: '/oldProductNewSuppPricingApproval',
        name: 'oldProductNewSuppPricingApproval',
        component: () => import('@/views/OldProductNewSuppPricingApproval/index')
      },
      // 价格有效期变更单审批
      {
        path: '/priceLifespanChangeApproval',
        name: 'priceLifespanChangeApproval',
        component: () => import('@/views/PriceLifespanChangeApproval/index')
      },
      // 开单期限申请审批
      {
        path: '/deliveryDueApplyApproval',
        name: 'deliveryDueApplyApproval',
        component: () => import('@/views/DeliveryDueApplyApproval/index')
      },
      // 开单期限变更审批
      {
        path: '/deliveryDueModifyApproval',
        name: 'deliveryDueModifyApproval',
        component: () => import('@/views/DeliveryDueModifyApproval/index')
      },
      // 提前送货申请审批
      {
        path: '/deliveryAdvanceApplyApproval',
        name: 'deliveryAdvanceApplyApproval',
        component: () => import('@/views/DeliveryAdvanceApplyApproval/index')
      },
      // 大宗原料行情审批
      {
        path: '/commodityQuotationApplyApproval',
        name: 'commodityQuotationApplyApproval',
        component: () => import('@/views/CommodityQuotationApplyApproval/index')
      },
      // 配额调整审批
      {
        path: '/quotaMaintenanceApproval',
        name: 'quotaMaintenanceApproval',
        component: () => import('@/views/QuotaMaintenanceApproval/index')
      },
      // 询价比发布审批
      {
        path: '/pmPriceCompApproval',
        name: 'pmPriceCompApproval',
        component: () => import('@/views/PmPriceCompApproval/index')
      },
      // 采购评标公告审批
      {
        path: '/purEvaluationReportApproval',
        name: 'purEvaluationReportApproval',
        component: () => import('@/views/PurEvaluationReportApproval/index')
      },
      // 采购合同验收审批
      {
        path: '/contractAcceptanceApproval',
        name: 'contractAcceptanceApproval',
        component: () => import('@/views/ContractAcceptanceApproval/index')
      },
      // 采购合同变更
      {
        path: '/purchaseContractChangeApproval',
        name: 'purchaseContractChangeApproval',
        component: () => import('@/views/PurchaseContractChangeApproval/index')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
